// @flow
import type {ApplicationStoreType} from 'constants/flow/flowTypes';

/**
 * Returns current Data Layer.
 * @param {{dataLayer: DataLayerType}} store - Data Layer.
 * @returns {DataLayerType} - Stored Data Layer.
 */
export const getDataLayer = (store: ApplicationStoreType) => store.dataLayer;
